import {
  Box,
  Container,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import aboutbg from "./assets/about-bg.png";
import apes from "./assets/apecouple.png";
import c1 from "./assets/Couple1.png";
import c2 from "./assets/Couple2.png";
import c3 from "./assets/Couple3.png";
import c4 from "./assets/Couple4.png";
import pinkheart from "./assets/pinkheart.png";

function About() {
  const flexMargin = useMediaQuery("(max-width:839px)");

  const [_rImge, _setrImage] = useState("");
  const imges = [apes, c1, c2, c3, c4];

  // const switchImg = () => {
  //   if (intervelIndex < 5) {
  //     setIntervalIndex(intervelIndex + 1);
  //   } else if (intervelIndex === 5) {
  //     setIntervalIndex(0);
  //   }
  // };
  // setInterval(switchImg, 5000);
  // useEffect(() => {}, []);

  React.useEffect(() => {
    const init = () => {
      setInterval(() => {
        var _item = imges[Math.floor(Math.random() * imges.length)];
        _setrImage(_item);
      }, 3500);
    };
    init();
  }, []);

  return (
    <div>
      <div id="aboutus">
        <Box
          mt="-20px"
          display="flex"
          flexDirection="column"
          textAlign="center"
          justifyContent="center"
          pb="15rem"
          // mt={16}
          sx={{
            backgroundImage: `url(${aboutbg})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "cover",
            paddingTop: "30px",
          }}
          width="100%"
          m="auto"
        >
          <Typography
            fontSize={{ xs: "26px", sm: "32px", md: "55px" }}
            variant="h3"
            color="white"
            sx={{
              fontWeight: "700",
              fontFamily: "'Baloo Bhai 2', cursive",
              textShadow: "0px 0px 20px #FFFFFF",
            }}
            mt={18}
          >
            ABOUT SOULMAPES
          </Typography>

          <Container maxWidth="md">
            <Stack
              mt={flexMargin ? 10 : 0}
              pt={15}
              pb={23}
              direction="row"
              alignItems="center"
              flexWrap="wrap"
              justifyContent="space-evenly"
            >
              <Box
                mt={-18}
                width={flexMargin ? "100%" : "40%"}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  src={_rImge ? _rImge : imges[0]}
                  style={{
                    maxWidth: "311.84px",
                    width: "100%",
                    marginTop: "30px",
                    borderRadius: "20px",
                  }}
                  alt=""
                />
              </Box>
              <Box
                sx={{
                  display: flexMargin ? "flex" : "flex",
                  alignItems: flexMargin ? "center" : "center",
                  justifyContent: flexMargin ? "center" : "center",
                  width: flexMargin ? "100%" : "50%",
                }}
              >
                <Typography
                  paragraph
                  mt={15}
                  maxWidth="450px"
                  width="100%"
                  margin="40px auto 160px auto"
                  color="white"
                  sx={{ fontFamily: "'Baloo Bhai 2', cursive" }}
                >
                  Inspired by the famous Pont de Arts, Love Lock Bridge in
                  Paris, France, SoulMapes is looking to capture the feeling of
                  love within its community. Planning on launching the first
                  “Bridge of Love '' in the metaverse, our mission behind the
                  project is hoping to bring loved ones together wherever they
                  may be in the world.
                </Typography>
              </Box>
            </Stack>
          </Container>

          {/* <Box sx={{ position: "relative" }}>
            <img
              className="zoom-in-out-box"
              style={{
                width: "100%",
                maxWidth: "89px",
                height: "auto",
                position: "absolute",
                top: "90px",
              }}
              src={pinkheart}
            />
          </Box> */}
        </Box>
      </div>
    </div>
  );
}

export default About;
